import React from 'react';
import { t } from '@citrite/translate';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { useLogoCompressionBreakpoint } from 'App/Header/useLogoCompressionBreakpoint';

const citrixWorkSpaceLogo = require('css/img/citrix-workspace-logo.svg');

const StyledLink = styled(Link)`
	display: flex;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
`;

export const Title = () => {
	const theme = useTheme();
	const logoURL = theme?.branding?.links?.HeaderLogoUrl;
	const chosenLogo = logoURL || citrixWorkSpaceLogo;
	const { compressedDims } = useLogoCompressionBreakpoint(chosenLogo);

	return (
		<StyledLink data-testid="workspaceLogo" to="/home" id="workspace-logo-link">
			{chosenLogo && (
				<img
					src={chosenLogo}
					alt={t('Workspace:document_title')}
					style={compressedDims ? { ...compressedDims } : { height: '40px' }}
				/>
			)}
		</StyledLink>
	);
};
